var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94074 5.00037L9.45879 8.5216C9.71902 8.78207 9.71883 9.20418 9.45837 9.46441C9.1979 9.72464 8.77579 9.72445 8.51556 9.46398L4.99723 5.94247L1.47073 9.46374C1.21019 9.7239 0.788076 9.72358 0.52792 9.46304C0.267764 9.2025 0.268078 8.78039 0.528621 8.52023L4.05485 4.99924L0.530156 1.47135C0.269925 1.21089 0.270115 0.788777 0.530583 0.528545C0.79105 0.268313 1.21316 0.268504 1.47339 0.528972L4.99836 4.05713L8.51563 0.545083C8.77618 0.284927 9.19829 0.285241 9.45844 0.545784C9.7186 0.806327 9.71828 1.22844 9.45774 1.48859L5.94074 5.00037Z",
    fill: "#696974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBadge);
export default __webpack_public_path__ + "static/media/closeBadge.fb18bfca4d9796f31eaf4fa3b28d2109.svg";
export { ForwardRef as ReactComponent };